import React from "react";
import Post from "./Post.jsx";

/* The PostingList is going to load all the posts in the system.  This model won't work well if you have a lot of 
  posts - you would want to find a way to limit the posts shown. */

export default class PostingList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      posts: [],
      listType: props.listType,
      prevSearch: this.props.sortValue,
      additions:[],
      additionsNotSplit:[],
      cc: []
    };
    this.postingList = React.createRef();
    this.loadPosts = this.loadPosts.bind(this);
  }

  // the first thing we do when the component is ready is load the posts.  This updates the props, which will render the posts  
  componentDidMount() {
    console.log("LoadingPosts")
    fetch(process.env.REACT_APP_API_PATH + "/connections?fromUserID=" + sessionStorage.getItem('user'), {
      method: "get",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem("token")
      }
    })
    .then(res => res.json())
    .then(
      result => {
        const blockCons = result[0].filter(conn => conn.attributes.type === "blocking");
        const followCons = result[0].filter(conn=>conn.attributes.type==="friend");
        let blockedUsers = [];
        for (let conn of blockCons) {
          blockedUsers.push(conn.toUser.id);
        }
        let followedUsers = [];
        for (let conn of followCons) {
          followedUsers.push(conn.toUser.id);
        }
        this.setState({
          blocking: blockedUsers,
          following: followedUsers
        })
        this.loadPosts();
      },
      error => {
        this.setState({
          isLoaded: true,
          error
        });
        console.log("ERROR loading Posts")
      }
    )
  }

  // if a parent component wants us to refresh, they can update the refresh value in the props passed in; this should also trigger a 
  // reload of the posting list
  componentDidUpdate(prevProps) {
    console.log("PrevProps " + prevProps.refresh);
    console.log("Props " + this.props.refresh);
    if (prevProps.refresh !== this.props.refresh) {
      this.loadPosts();
    }
  }
  calculate(a,b){
    var bLikes = 0
    var aLikes = 0
    for(let reaction in b.reactions){
          console.log("index:", reaction, b.reactions[reaction]);
          if(b.reactions[reaction].name=="like"){
            bLikes +=1;
            console.log(bLikes);
        }
    }
    for(let reaction in a.reactions){
        if(a.reactions[reaction].name=="like"){
          aLikes +=1;
          console.log(aLikes);
      }
  }
  console.log("bLikes: ", bLikes, "aLikes: ", aLikes)
  return bLikes-aLikes;
  }
  loadPosts() {
    // if the user is not logged in, we don't want to try loading posts, because it will just error out.  
    if (sessionStorage.getItem("token")) {
      let url = process.env.REACT_APP_API_PATH + "/posts?parentID=";

      // if there is a parentid passed in, then we are trying to get all the comments for a particular post or comment, so
      // we will restrict the fetch accordingly.
      if (this.props && this.props.parentid) {
        url += this.props.parentid;
      }
      console.log("postinglistprops", this.props.sortValue)
      if(this.props.sortIndex==0){
        url+= "&sort=newest";
      }
      else if(this.props.sortIndex==1){
        url+="&sort=oldest";
      }
      fetch(url, {
        method: "get",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + sessionStorage.getItem("token")
        },

      })
        .then(res => res.json())
        .then(
          result => {
            if (result) {
              var filteredPosts = result[0].filter(post => !this.state.blocking.includes(post.authorID)&&this.state.following.includes(post.authorID))
              var added = result[0].filter(post => !this.state.blocking.includes(post.authorID)&&!this.state.following.includes(post.authorID)&& (post.attributes.storyPrivacy  == "Public" || post.authorID == sessionStorage.getItem("user")))
              var toAdd = added.sort((a,b) => (b.created - a.created)).slice(0, 5)
              if(this.props.sortIndex==2){
                filteredPosts.sort(this.calculate)
                toAdd = added.sort(this.calculate).slice(0,5)
                console.log("Filtered Posts: ", filteredPosts)
              }
              else if(this.props.sortIndex==3){
                filteredPosts.sort((a, b)=> (b._count.children - a._count.children));
                toAdd = added.sort((a,b) => (b._count.children - a._count.children)).slice(0, 5)
              }
              else if(this.props.sortIndex==1){
                filteredPosts.sort((a,b) => (a.created - b._created))
                toAdd = added.sort((a,b) => (a.created - b._created)).slice(0, 5)
                console.log("toAdd", toAdd)
              }
              this.setState({
                isLoaded: true,
                posts: filteredPosts,
                additions: toAdd.filter(post=>post.id!=269&&post.id!=270),
                additionsNotSplit: filteredPosts.concat(added).filter(post=>post.id!=269&&post.id!=270)
              });
              console.log("Got Posts", this.state.additionsNotSplit);
            }
          },
          error => {
            this.setState({
              isLoaded: true,
              error
            });
            console.log("ERROR loading Posts")
          }, () =>{
            this.loadCraftingCannon()
          }
        );
    }
  }
  loadCraftingCannon(){
    fetch(process.env.REACT_APP_API_PATH + "/posts?authorID=113", {
      method: "GET",
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + sessionStorage.getItem("token")
      }
  })
      .then(res => res.json())
      .then(
          response => {
              this.setState({
                  cc: response[0],
              })
              console.log(response,this.state.cc, "AAAAAAAAAAA")
            })
          
  }

  render() {

    const { error, isLoaded, posts, additionsNotSplit, additions } = this.state;
    if (error) {
      return <div> Error: {error.message} </div>;
    }
    else if (!isLoaded) {
      return <div> Loading... </div>;
    }
    else if (additionsNotSplit) {
      if(this.state.prevSearch!=this.props.sortValue){
        this.setState({
          prevSearch: this.props.sortValue
        }, () =>{
          this.loadPosts();
        })
      }
      if (additionsNotSplit.length > 0) {
        // -------------------------------------------------
        let renderPost
        let renderAdditions
        let searchWord = this.props.searchWord
        let newPostsList = []
        let newAdditionsList = []
        
        if (posts.length == 0 && this.state.cc.length ==0){
          this.loadCraftingCannon();
        }
        if (searchWord.length > 0) { // render post based on search word (case-insensitive)
          console.log("ans", additionsNotSplit,posts)
          newPostsList = posts.filter(post => (
            post.attributes.title.toLowerCase().includes(searchWord.toLowerCase())
            ||
            post.content.toLowerCase().includes(searchWord.toLowerCase())
          ))
          console.log("newPosts", newPostsList)
          if (newPostsList.length==0 || (newPostsList.length==1&&newPostsList[0].id==269)){
            this.loadCraftingCannon();
            newPostsList = this.state.cc.splice(1,1);
            console.log("newPostsList", newPostsList, this.state.cc,this.state.cc.splice(1,1))
          }
          newAdditionsList = additionsNotSplit.filter(post => ( (!this.state.following.includes(post.authorID)) &&
            (post.attributes.title.toLowerCase().includes(searchWord.toLowerCase())
            ||
            post.content.toLowerCase().includes(searchWord.toLowerCase()))
          ))
          if(newAdditionsList.length==0){
            newAdditionsList = this.state.cc.splice(0,1);
          }
          console.log("newAdditionsaaaaa", newAdditionsList);
          renderPost = newPostsList.map(post => (
            <Post childrenCount={post._count["children"]} key={post.id} post={post} type={this.props.type} onHomepage={true} loadPosts={this.loadPosts} comment={false} />
          ))
          renderAdditions = newAdditionsList.map(post => (
            <Post childrenCount={post._count["children"]} key={post.id} post={post} type={this.props.type} onHomepage={true} loadPosts={this.loadPosts} comment={false} />
          ))

        }
        else { // normal render posts
          renderPost = posts.map(post => (
            <Post childrenCount={post._count["children"]} key={post.id} post={post} type={this.props.type} onHomepage={true} loadPosts={this.loadPosts} comment={false} />
          ))
          if(renderPost.length==0){
            renderPost = this.state.cc.splice(1,1).map(post => (
              <Post childrenCount={post._count["children"]} key={post.id} post={post} type={this.props.type} onHomepage={true} loadPosts={this.loadPosts} comment={false} />
            ))
          }
          renderAdditions = additions.map(post =>(
            <Post childrenCount={post._count["children"]} key={post.id} post={post} type={this.props.type} onHomepage={true} loadPosts={this.loadPosts} comment={false} />
          ))
        }
        // -------------------------------------------------
        return (
          <div className="posts">
            <label className="homepageFeed">Following Feed</label>
            <br></br><br></br>
            <div className = "followingFeed">
            {renderPost}
            </div>
            <label className="homepageFeed">Launch Towards Other Users!</label>
            <br></br><br></br>
            <div className = "extraFeed">
              {renderAdditions}
            </div>
          </div>
        )
      }
      else {
        return (<div> No Posts Found </div>);
      }
    }
    else {
      return <div> Please Log In... </div>;
    }

  }
}